import React from 'react';

const Close = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.163 26.163">
        <g fill="currentColor" fillRule="nonzero">
            <rect
                width="33"
                height="4"
                x="-3.419"
                y="11.081"
                rx="2"
                transform="scale(-1 1) rotate(45 0 -18.5)"
            />
            <rect
                width="33"
                height="4"
                x="-3.419"
                y="11.081"
                rx="2"
                transform="rotate(45 13.081 13.081)"
            />
        </g>
    </svg>
);

export default Close;
